'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = exports.HamburgerButton = undefined;

var _class2, _temp;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    z-index: 10;\n    top: 0;\n    right: -100%;\n    height: 100%;\n    transition: right ease-in-out 0.35s;\n    position: fixed;\n    outline: none;\n    background-color: rgba(0,0,0,0.9);\n    color: white;\n    padding-top: 65px;\n    text-align: center;\n    overflow-y: scroll;\n\n    .mobile-open & {\n        right: 0;\n    }\n'], ['\n    display: block;\n    z-index: 10;\n    top: 0;\n    right: -100%;\n    height: 100%;\n    transition: right ease-in-out 0.35s;\n    position: fixed;\n    outline: none;\n    background-color: rgba(0,0,0,0.9);\n    color: white;\n    padding-top: 65px;\n    text-align: center;\n    overflow-y: scroll;\n\n    .mobile-open & {\n        right: 0;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: block;\n    cursor: pointer;\n    user-select: none;\n    width: 35px;\n    & span {\n        height: 4px;\n        width: 35px;\n        border-radius: 2px;\n        background-color: black;\n        position: relative;\n        display: block;\n        transition: all .2s ease-in-out;\n        &:before {\n            top: -10px;\n            visibility: visible;\n        }\n        &:after {\n            top: 10px;\n        }\n        &:before, &:after {\n            height: 4px;\n            width: 100%;\n            border-radius: 2px;\n            background-color: black;\n            position: absolute;\n            content: "";\n            transition: all .2s ease-in-out;\n        }\n    }\n\n    &:hover span,\n    &:hover span:before,\n    &:hover span:after {\n        background: ', ';\n    }\n\n    &.open {\n        &:hover span, span{\n            background: transparent;\n        }\n        span {\n            &:before {\n                transform: rotate(45deg) translate(7px, 7px);\n                opacity: 1;\n            }\n            &:after {\n                transform: rotate(-45deg) translate(7px, -7px);\n            }\n        }\n    }\n'], ['\n    display: block;\n    cursor: pointer;\n    user-select: none;\n    width: 35px;\n    & span {\n        height: 4px;\n        width: 35px;\n        border-radius: 2px;\n        background-color: black;\n        position: relative;\n        display: block;\n        transition: all .2s ease-in-out;\n        &:before {\n            top: -10px;\n            visibility: visible;\n        }\n        &:after {\n            top: 10px;\n        }\n        &:before, &:after {\n            height: 4px;\n            width: 100%;\n            border-radius: 2px;\n            background-color: black;\n            position: absolute;\n            content: "";\n            transition: all .2s ease-in-out;\n        }\n    }\n\n    &:hover span,\n    &:hover span:before,\n    &:hover span:after {\n        background: ', ';\n    }\n\n    &.open {\n        &:hover span, span{\n            background: transparent;\n        }\n        span {\n            &:before {\n                transform: rotate(45deg) translate(7px, 7px);\n                opacity: 1;\n            }\n            &:after {\n                transform: rotate(-45deg) translate(7px, -7px);\n            }\n        }\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral([''], ['']),
    _templateObject4 = _taggedTemplateLiteral(['\n            body.mobile-open & {\n                overflow-y: hidden;\n            }\n        '], ['\n            body.mobile-open & {\n                overflow-y: hidden;\n            }\n        ']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


/*::
type MobileMenuLayerProps = {|
    className?: string,
    children: React.Node,
    onClick: void,
|}
type MobileMenuLayerState = {|
|}
*/
var MobileMenuLayer = (0, _styledComponents2.default)(function (_React$Component) {
  _inherits(_class, _React$Component);

  /*:: containerEl: HTMLDivElement */
  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    if (typeof document !== 'undefined') {
      _this.containerEl = document.createElement('div');
    }
    return _this;
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof document !== 'undefined') {
        // $FlowFixMe el body existe
        document.body.appendChild(this.containerEl);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (typeof document === 'undefined') {
        return null;
      }
      var _props = this.props,
          className = _props.className,
          children = _props.children;


      return _reactDom2.default.createPortal(React.createElement(
        'aside',
        { className: className },
        children
      ), this.containerEl);
    }
  }]);

  return _class;
}(React.Component /*:: <MobileMenuLayerProps, MobileMenuLayerState> */))(_templateObject);

var HamburgerButton = exports.HamburgerButton = (0, _styledComponents2.default)(function (props) {
  return React.createElement(
    'div',
    props,
    React.createElement('span', null)
  );
})(_templateObject2, _styles.styles.colors.title_decoration);

/*::
type MobileMenuProps = {|
    children: React.Node,
|}
type MobileMenuState = {|
    open: bool,
|}
*/
var MobileMenu = exports.MobileMenu = (0, _styledComponents2.default)((_temp = _class2 = function (_React$Component2) {
  _inherits(_class2, _React$Component2);

  function _class2() {
    _classCallCheck(this, _class2);

    var _this2 = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));

    _this2.toggleMenu = function () {
      return _this2.setState(function (prevState) {
        return Object.assign({}, prevState, {
          open: !prevState.open
        });
      });
    };

    _this2.state = {
      open: false
    };
    return _this2;
  }

  _createClass(_class2, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Prevents scrolling when the menu is open
      (0, _styledComponents.injectGlobal)(_templateObject4);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (typeof document === 'undefined') {
        return null;
      }
      var body = document.querySelector('body');
      // $FlowFixMe siempre hay un body;
      var classNames = body.className;
      if (nextState.open) {
        // $FlowFixMe siempre hay un body;
        body.className = classNames + ' mobile-open';
      } else {
        // $FlowFixMe siempre hay un body;
        body.className = classNames.replace(/\s+mobile-open/g, '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var open = this.state.open;


      return React.createElement(
        React.Fragment,
        null,
        React.createElement(HamburgerButton, { className: '' + (open ? 'open' : ''),
          onClick: this.toggleMenu }),
        React.createElement(
          MobileMenuLayer,
          { onClick: this.toggleMenu },
          children
        )
      );
    }
  }]);

  return _class2;
}(React.Component /*:: <MobileMenuProps, MobileMenuState> */), _class2.displayName = 'MobileMenu', _temp))(_templateObject3);


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/MobileMenu.js
// module id = 131
// module chunks = 0